import React, { useEffect, useState, useRef, useContext } from 'react'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import '../css/landing.css'
import Rightcontainer from '../Components/Rightcontainer'
import Downloadbutton from '../Components/Downloadbutton'
import DownloadPopup from '../Components/DownloadPopup'
import io from '../Components/socket'
import Header from '../Components/Header'
import { Token } from '@mui/icons-material'
import SliderCode from '../Components/SliderCode'
import { LanguageContext } from '../Components/LanguageContext'
import { useTheme } from '../../ThemeContext'

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false)
  const [showDownloadPopup, setShowDownloadPopup] = useState(true)
  const udata = localStorage.getItem("udata");
   let profileData = JSON.parse(udata);
  // const [userAllData, setUserAllData] = useState()

  // language
  const translations = {
    hi: { Tournaments: 'प्रतियोगिता' },
    en: { Tournaments: 'Tournaments' },
  };


  const MyData = localStorage.getItem('meData')
  const meedata = JSON.parse(MyData)
  const { language } = useContext(LanguageContext);

  const addsetting = localStorage.getItem('sitSetting')
  const addCaseSetting = JSON.parse(addsetting)
  // console.log(addCaseSetting);

  // const role = async () => {
  //   const access_token = localStorage.getItem('token')
  //   io.emit('getprofile', access_token)
  //   io.on('setProfile', data => {
  //     // setUserAllData(data)
  //   })
  // }

  useEffect(() => {
    // role()
  }, [])
  // change theme 
  const theme = localStorage.getItem("theme")
  

  const styles = {
    backgroundColor: theme === 'light' ? '#rgb(255, 255, 255)' : 'black',
    color: theme === 'light' ? 'black' : '#fff',
    // marginTop: 'inherit',
    // padding: '20px',
    // margin: '20px',
  };

  const styles3 = {
    backgroundColor: theme === 'light' ? '#rgb(255, 255, 255)' : '#27241b',
    color: theme === 'light' ? '#fff' : '#fff',
  };
   useEffect(() => {
      // console.log("ok");
      const UserId = localStorage.getItem("userId");
      socket.on("setProfile", (data) => {
        profileData = data;
  
        // userId = data?._id;
      });
    }, [socket]);
  const history = useHistory();
    const handleClick = (e) => {
      if (profileData?.verified === "unverified") {
        e.preventDefault(); // page pe jaane se roke
        Swal.fire({
          icon: "warning",
          html: `
      <div className="kyc-box">
                <div className="kyc-text">KYC Pending</div>
                <button className="kyc-btn">Complete Here</button>
              </div>`,
          background: "linear-gradient(135deg, #1e3a8a, #0f172a)",
          confirmButtonText: "Verify Now",
          confirmButtonColor: "#f59e0b",
        }).then((result) => {
          if (result.isConfirmed) {
            history.push("/Profile"); // ✅ redirect
          }
        });
  
        return;
      }
      history.push("/");
    };

  return (
    <>
      {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />}
    


      <div className='leftContainer mb_space' style={{ ...styles, height: "119% !important" }}>  

        <div className='pt-0 Orher_page_main_section' style={styles}>

          <div className='main-area' style={styles}>
         
            {/* <SliderCode /> */}

        
            {/* KYC Pending and Notice bar */}
            <div className="banners-row">
              {profileData?.verified === "unverified" ? (
                  <div className="kyc-box">
                    <div className="kyc-text">KYC Pending</div>
                    <button className="kyc-btn">Complete Here</button>
                  </div>
                ) : null}
              <div className="notice-box">
                <div className="notice-text">Notice:-WhatsApp. {JSON.parse(localStorage.getItem('sitSetting'))?.site_message }</div>
              </div>
            </div>
            {/* <h6 className="text-danger blink" style={{ fontSize: "16px" }}> Live</h6> */}
            {/* <div>

              <Link
                className='gameCard-container'
                to={addCaseSetting?.isLudokingClassic ? '/Homepage/ludoClassicManual' : '#'}
              >
                <img className='w-100 mb-2 curverd-class' src='/mainimage/barimage.jpg' />
              </Link>

            </div> */}

            <section className='games-section' style={styles}>
              {/* <h5 className='h5-bold'>PLAY GAMES WITH NKADDA</h5> */}

              <div className='games-section-headline mt-0 pb-2 mb-sm-5 mb-3'>
                <div className='games-window '>
                  <div className='games-header-row'>
                    <h2 className='games-title'>Games</h2>
                    <button className='rules-btn'>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" class="me-1"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path></svg>
                      <span className='ml-1'>Rules </span></button>
                  </div>


                  <>

                    {/* LUDO CLASSIC MANUAL */}

                    <Link
                      className='gameCard-container'
                      to={addCaseSetting?.isLudokingClassic ? '/Homepage/ludoClassicManual' : '#'}
                    >
                      <div className={`gameCard bigCard`}>
                        <div className='app-mode'>APP MODE</div>
                        <picture className='gameCard-image'>
                          <img
                            width='100%'
                            src='./mainimage/Ludo_Classic.png'
                            alt='Ludo Classic'
                          />
                          
                        </picture>
                      </div>
                    </Link>


                    {

                      <>
                        {/* NKADDA CLASSIC */}

                        {/* <Link
                          className='gameCard-container'
                          to={addCaseSetting?.NKADDAClassic ? '/Homepage/popular' : '#'}
                        >
                          <div className={`gameCard`}>
                            <span className='d-none blink  d-block text-right bg_green game_live_status_position'>

                              {addCaseSetting?.isLudokingClassic ? ' ◉ Comming Soon' : ' ◉ Comming Soon'}
                            </span>
                            <picture className='gameCard-image'>
                              <img
                                width='100%'
                                src='./mainimage/ludopopular.jpg'
                                alt='Ludo Classic'
                              />
                            </picture>
                          </div>
                        </Link> */}


                        {/* NKADDALUDO */}

                        {/* <Link
                            className='gameCard-container'
                            to={addCaseSetting?.NKADDALudo ? '/Homepage/ludoulta1' : '#'}
                          >
                            <div className={`gameCard`}>
                              <span className='d-none blink  d-block text-right text-white bg_green game_live_status_position'>

                                {addCaseSetting?.NKADDALudo ? ' ◉ LIVE' : '  ◉ COMING SOON'}
                              </span>
                              <picture className='gameCard-image'>
                                <img
                                  width='100%'
                                  src='./mainimage/ludosnake.jpg'
                                  alt='Ludo Classic'
                                />
                              </picture>
                            </div>
                          </Link> */}

                        {/* NKADDAONE */}
                        <a
                          href={
                            JSON.parse(localStorage.getItem("sitSetting")) ==
                              "undefined"
                              ? ""
                              : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.whatsappSupport
                          }
                          target="_blank"
                          className='gameCard-container'
                        >
                          <div className={`gameCard bigCard`}>
                            <div className='app-mode'>APP MODE</div>
                            <picture className='gameCard-image'>
                              <img
                                width='100%'
                                src='./mainimage/ludosupport.png'
                                alt='Ludo Classic'
                              />
                            </picture>
                          </div>
                        </a>
                      </>
                    }
                  </>
                </div>
                <div>

                </div>
              </div>
            </section>

            {/* floating chat icon */}
            <div className="floating-chat">
              <img src="/images/Prototype-Demo-QR-code.ppm" alt="chat" style={{ width: 36, height: 36 }} />
            </div>

            {/* 
            <div className='downloadButton'>
              <Downloadbutton />
            </div> */}
          </div>
        </div>
      </div>
      <div className="support_samll_card_btn_type whatsap_btn">
        {JSON.parse(localStorage.getItem("sitSetting")) ==
          "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))
          ?.whatsappSupport ? (
          <>
            <a
              href={
                JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.whatsappSupport
              }
              target="_blank"
            >
              {/* <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                alt=""
              /> */}
            </a>
          </>
        ) : (
          ""
        )}
      </div>
      <div className="support_samll_card_btn_type whatsap_btn" style={{ marginBottom: "65px" }}>
        {JSON.parse(localStorage.getItem("sitSetting")) ==
          "undefined" ? (
          ""
        ) : JSON.parse(localStorage.getItem("sitSetting"))
          ?.CompanyMobile ? (
          <>
            {/* <a
              href={
                `tel:${JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                    ?.CompanyMobile}`
              }
              target="_blank"
            >
              <img
                width="40px"
                src={process.env.PUBLIC_URL + "/images/phone.png"}
                alt=""
              />
            </a> */}
          </>
        ) : (
          ""
        )}

      </div>

      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </>
  )
}
